import {useState} from "react";

export const TYPES = {
    REQUIRED:'REQUIRED',
    MIN:'MIN',
    MAX:'MAX',
    MINMAX:'MINMAX'
}

export function useValidator(validators){
    const [errors, setErrors] = useState({});
    function validations(values,validators){
        var errors = {};
        function validate({type,pattern,value}){
            if(type===TYPES.REQUIRED && !value) return false
            if(type===TYPES.MIN && value?.length<pattern.min) return false
            return true;
        }
    
        if(values?.target){
            if(!values.target?.name) throw new Error('Field must have name attribute')
            values = {
                [values.target.name]:values.target?.value || values.target?.checked
            }
        }
        for(const key in values){
            const _value = values[key]
            const _validations = validators[key] || []
            for(const v of _validations){
                if(!validate({...v,value:_value})){
                    errors[key] = true;
                    break;
                }
            }
        }
        if(Object.entries(errors)?.length) return {ok:false,errors}
        else return {ok:true};
    }
    const validate = (values) => {
        const validation = validations(values, validators);
        if (!validation.ok) {
          setErrors(validation.errors);
          return false;
        }
        setErrors({});
        return true;
    };

    return [errors,validate]
}
export default useValidator;